/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-unused-vars */

import React from 'react';
import { Button } from 'antd';
import classNames from 'classnames';
import LinkedInIcon from '../assets/svgIcons/LinkedInIcon';
import GlobalStyle from '../../auth/components/GlobalStyle';

type Props = {
  disabled?: boolean;
  Icon?: object;
  title?: string;
  rightIcon?: boolean;
  onButtonClick?: (e: React.MouseEvent<HTMLButtonElement>) => void;
} & typeof defaultProps;

const defaultProps = {
  rightIcon: false,
  disabled: false,
  title: '',
  Icon: LinkedInIcon,
  onButtonClick(e: React.MouseEvent<HTMLButtonElement>) { },
};

const IconButton = function IconButton(props: Props) {
  const {
    Icon,
    disabled,
    title,
    onButtonClick,
    rightIcon,
  } = props;

  return (
    <>
      <GlobalStyle />
      <Button
        icon={<Icon />}
        size="small"
        disabled={disabled}
        onClick={onButtonClick}
        className={classNames('ant-icon-button d-flex align-items-center border-0', { rightIconAlign: rightIcon })}
        aria-label={title}
      >
        {title}
      </Button>
    </>
  );
};

IconButton.defaultProps = defaultProps;
export default IconButton;
